export default "__VITE_ASSET__CZUs0Wda__"